<template>
  <div class="homeIndexNews HomeContainer">
    <div class="newsItem">
      <div class="title">
        <img :src="GetResourceUrl('index/icon-price.svg')" />
        <span>{{l("今日网价")}}</span>
        <div class="subTitle">{{l("原料价格抢先知")}}</div>
        <router-link class="more" to="/home/market_price">{{l("更多")}}>></router-link>
      </div>
      <div class="priceTableHead">
        <div class="first">{{ l(marketPrice.titleList[0]) }}</div>
        <div>{{ marketPrice.titleList[1] }}</div>
        <div>{{ marketPrice.titleList[2] }}</div>
        <div>{{ marketPrice.titleList[3] }}</div>
        <div>{{ marketPrice.titleList[4] }}</div>
        <div>{{ marketPrice.titleList[5] }}</div>
      </div>
      <Carousel
        class="priceTableRowContainer"
        :initList="marketPrice.priceList"
        :childHeight="62"
        :parentHeight="386"
        :speed="0.4"
      >
        <template #default="scope">
          <div
            class="priceTableRow"
            :style="{
              height: scope.childHeight + 'px',
            }"
          >
            <div class="first" :title="scope.item[0]">
              {{ l(scope.item[0]) }}
            </div>
            <div v-for="i in 5" :key="i">
              <div>{{ scope.item[i].num }}</div>
              <div v-show="scope.item[i].plus" class="plus">
                {{ scope.item[i].plus }}
              </div>
              <div v-show="scope.item[i].minus" class="minus">
                {{ scope.item[i].minus }}
              </div>
              <div v-show="scope.item[i].fix">
                {{ scope.item[i].fix }}
              </div>
            </div>
          </div>
        </template>
      </Carousel>
    </div>
    <div class="newsItem">
      <div class="title">
        <img :src="GetResourceUrl('index/icon-market.svg')" />
        <span>{{l("行情中心")}}</span>
        <div class="subTitle">{{l("行情资讯一手抓")}}</div>
        <router-link class="more" to="/home/article">{{l("更多")}}>></router-link>
      </div>
      <div class="articleGroup">
        <div class="articleContainer">
          <div class="articleTitle">
            <img :src="GetResourceUrl('index/icon-exhibition.svg')" />
            <div class="title">{{l("动态")}}</div>
          </div>
          <div class="articleList">
            <div
              class="articleItem"
              v-for="item in articleList_1"
              :key="item.id"
            >
              <router-link :to="'/home/article/detail/' + item.id">{{
                item.title
              }}</router-link>
              <div class="articleDate">
                {{ item.custom_created_time.slice(5, 10) }}
              </div>
            </div>
          </div>
        </div>
        <div class="articleContainer">
          <div class="articleTitle">
            <img :src="GetResourceUrl('index/icon-focus.svg')" />
            <div class="title">{{l("聚焦")}}</div>
          </div>
          <div class="articleList">
            <div
              class="articleItem"
              v-for="item in articleList_2"
              :key="item.id"
            >
              <router-link :to="'/home/article/detail/' + item.id">{{
                item.title
              }}</router-link>
              <div class="articleDate">
                {{ item.custom_created_time.slice(5, 10) }}
              </div>
            </div>
          </div>
        </div>
        <div class="articleContainer">
          <div class="articleTitle">
            <img :src="GetResourceUrl('index/icon-explain.svg')" />
            <div class="title">{{l("解读")}}</div>
          </div>
          <div class="articleList">
            <div
              class="articleItem"
              v-for="item in articleList_3"
              :key="item.id"
            >
              <router-link :to="'/home/article/detail/' + item.id">{{
                item.title
              }}</router-link>
              <div class="articleDate">
                {{ item.custom_created_time.slice(5, 10) }}
              </div>
            </div>
          </div>
        </div>
        <div class="articleContainer">
          <div class="articleTitle">
            <img :src="GetResourceUrl('index/icon-comments.svg')" />
            <div class="title">{{l("周评")}}</div>
          </div>
          <div class="articleList">
            <div
              class="articleItem"
              v-for="item in articleList_4"
              :key="item.id"
            >
              <router-link :to="'/home/article/detail/' + item.id">{{
                item.title
              }}</router-link>
              <div class="articleDate">
                {{ item.custom_created_time.slice(5, 10) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/gadget/Carousel.vue";

export default {
  name: "HomeIndexNews",
  components: { Carousel },
  data() {
    return {
      marketPrice: {
        titleList: [],
        priceList: [],
      },
      articleList_1: [],
      articleList_2: [],
      articleList_3: [],
      articleList_4: [],
    };
  },
  created() {
    this.getMarketPrice();
    this.getArticleList();
  },
  beforeDestroy() {},
  methods: {
    getMarketPrice() {
      this.axios
        .get("/api/website_dynamic/market_price/", {
          params: {},
        })
        .then((data) => {
          this.marketPrice = {
            titleList: data.info[0],
            priceList: data.info.slice(1).map((origin_arr) => {
              origin_arr = origin_arr.map((item, index) => {
                if (index == 0) {
                  return item;
                } else {
                  var obj = {
                    num: "-",
                    plus: null,
                    minus: null,
                    fix: null,
                  };
                  var arr = String(item).split(" ");
                  obj.num = arr[0];
                  if (arr[1] && arr[1].indexOf("+") == 0) {
                    obj.plus = arr[1];
                  } else if (arr[1] && arr[1].indexOf("-") == 0) {
                    obj.minus = arr[1];
                  } else {
                    obj.fix = arr[1];
                  }
                  return obj;
                }
              });
              return origin_arr;
            }),
          };
        });
    },
    getArticleList() {
      this.axios
        .get("/api/article/", {
          params: {
            type: "动态",
            size: 6,
            page: 1,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.articleList_1 = data.results;
        });

      this.axios
        .get("/api/article/", {
          params: {
            type: "聚焦",
            size: 6,
            page: 1,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.articleList_2 = data.results;
        });

      this.axios
        .get("/api/article/", {
          params: {
            type: "解读",
            size: 6,
            page: 1,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.articleList_3 = data.results;
        });

      this.axios
        .get("/api/article/", {
          params: {
            type: "周评",
            size: 6,
            page: 1,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.articleList_4 = data.results;
        });
    },
  },
};
</script>


<style scoped lang="scss">
.homeIndexNews {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .newsItem {
    width: 590px;
    background: #fff;
    > .title {
      display: flex;
      align-items: flex-end;
      padding: 26px 0 26px 15px;
      img {
        margin-right: 15px;
        width: 32px;
        height: 32px;
      }
      span {
        font-weight: bold;
        font-size: 24px;
      }
      .subTitle {
        font-size: 14px;
        color: #666;
        margin-left: 20px;
      }
      .more {
        margin-left: auto;
        font-size: 12px;
        color: $warningColor;
        margin-right: 10px;
      }
    }
  }
}
/deep/.el-carousel__item.is-animating {
  -webkit-transition: -webkit-transform 1s linear;
  transition: -webkit-transform 1s linear;
  transition: transform 1s linear;
  transition: transform 1s linear, -webkit-transform 1s linear;
}

.priceTableHead {
  background: #fff;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 18px;
  border-top: 1px solid $borderPlainColor;
  border-bottom: 1px solid $borderPlainColor;
  letter-spacing: 1px;
  display: flex;
  font-weight: bold;
  // 588-200-18=270
  div {
    width: 110px;
    text-align: center;
    &.first {
      width: 200px;
      text-align: left;
    }
  }
}
.priceTableRowContainer {
  overflow: hidden;
  .priceTableRow {
    // height: 34px;
    // line-height: 34px;
    box-sizing: border-box;
    padding-left: 18px;
    display: flex;
    border-bottom: 1px solid $borderPlainColor;
    & > div {
      width: 110px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &.first {
        width: 200px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      div {
        line-height: 24px;
      }
    }
    .plus {
      color: #ff7473;
    }
    .minus {
      color: #099d08;
    }
  }
}
.articleGroup {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .articleContainer {
    width: 50%;
    padding: 10px 10px;
    height: 212px;
    box-sizing: border-box;
    border-top: 1px solid $borderPlainColor;

    .articleTitle {
      height: 22px;
      line-height: 22px;
      display: flex;
      align-items: center;
      img {
        width: 17px;
        height: 17px;
        margin-right: 8px;
      }
      .title {
        flex-grow: 1;
        font-weight: bold;
        line-height: 17px;
      }
      .more {
        font-size: 12px;
        color: $warningColor;
        text-decoration: none;
        float: right;
      }
    }
    .articleList {
      height: 120px;
      margin-top: 8px;
      .articleItem {
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        display: flex;
        justify-content: space-between;
        a {
          width: 220px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            color: $warningColor;
            text-decoration: underline;
          }
        }
        .articleDate {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
}
</style>

